import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Trash2, Home, Archive, Car, Heart, Wrench, Recycle, Sparkles, Coins, Factory, Star, Check } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { allServices, promises, images } from '../data/mock';

const iconMap = {
  Trash2: Trash2,
  Home: Home,
  Archive: Archive,
  Car: Car,
  Heart: Heart,
  Wrench: Wrench,
  Recycle: Recycle,
  Sparkles: Sparkles,
  Coins: Coins,
  Factory: Factory,
  Star: Star
};

const ServicesPage = () => {
  useEffect(() => {
    // SEO: Dynamic page title and meta description
    document.title = 'Dienstleistungen | Entrümpelung, Haushaltsauflösung, Kellerräumung | Helper-Schweiz';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Alle Dienstleistungen von Helper-Schweiz: Entrümpelung, Haushaltsauflösung, Kellerräumung, Estrichräumung, Nachlassauflösung, Messie-Entrümpelung, Möbelentsorgung in Zürich, Bern, Luzern und der ganzen Deutschschweiz.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[#f0f5fa] to-[#e8f0f8] py-16">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-[#1e3a5f]">Meine Dienstleistungen</h1>
          <p className="mt-4 text-gray-600 text-lg max-w-2xl mx-auto">
            Professionelle Lösungen für Ihre Entrümpelungs- und Entsorgungsbedürfnisse
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {allServices.map((service) => {
              const IconComponent = iconMap[service.icon];
              return (
                <Card key={service.id} className="group hover:shadow-lg transition-all duration-300 border-0 shadow-md">
                  <CardContent className="p-6">
                    <div className="w-14 h-14 bg-[#f0f5fa] rounded-xl flex items-center justify-center mb-4 group-hover:bg-[#c41e3a] transition-colors">
                      {IconComponent && <IconComponent className="w-7 h-7 text-[#1e3a5f] group-hover:text-white transition-colors" />}
                    </div>
                    <h3 className="text-xl font-semibold text-[#1e3a5f] mb-2">{service.title}</h3>
                    <p className="text-gray-600">{service.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>

          {/* Weitere Dienstleistungen Hinweis */}
          <div className="mt-12 bg-[#f0f5fa] rounded-2xl p-8 text-center">
            <p className="text-gray-700 text-lg leading-relaxed">
              Neben den aufgeführten Serviceleistungen biete ich auch weitere unterstützende Dienstleistungen an.
            </p>
            <p className="text-[#1e3a5f] font-semibold text-lg mt-2">
              Gerne bespreche ich Ihr Anliegen unverbindlich persönlich.
            </p>
            <div className="mt-6">
              <Link to="/contact">
                <Button className="bg-[#1e3a5f] hover:bg-[#152a47] text-white px-8 py-3 rounded-full text-lg">
                  Kontakt aufnehmen
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Promise Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] text-center mb-4">Mein Versprechen</h2>
          <p className="text-gray-600 text-center mb-12 max-w-2xl mx-auto">
            Als Einzelunternehmer lege ich grössten Wert auf Qualität, Pünktlichkeit und Kundenzufriedenheit. Jeder Auftrag wird persönlich von mir mit Sorgfalt und Professionalität durchgeführt.
          </p>
          <div className="grid md:grid-cols-2 gap-4">
            {promises.map((promise, index) => (
              <div key={index} className="flex items-start gap-3 p-4 bg-[#f8fafc] rounded-lg">
                <Check className="w-5 h-5 text-[#c41e3a] mt-0.5 flex-shrink-0" />
                <span className="text-gray-700">{promise}</span>
              </div>
            ))}
          </div>
          <div className="text-center mt-12">
            <Link to="/contact">
              <Button className="bg-[#c41e3a] hover:bg-[#a31830] text-white px-8 py-3 rounded-full text-lg">
                Jetzt Anfrage stellen
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
